var _rect, _circle, _circle2, _g, _rect2, _line, _line2, _circle3, _circle4, _circle5, _rect3, _path, _rect4, _rect5, _rect6, _path2, _rect7, _circle6, _circle7, _circle8, _circle9, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "#5222D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4286_47379",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 160,
    height: 160
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "#5222D0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4286_47379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 183L157.803 25H160.159L100.205 183H-18Z",
    fill: "url(#paint0_linear_4286_47379)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 50.5,
    width: 141,
    height: 90,
    rx: 11.5,
    fill: "white",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53.5,
    y1: 67,
    x2: 53.5,
    y2: 141,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 66.5,
    x2: 167,
    y2: 66.5,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 59,
    r: 2.5,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 59,
    r: 2.5,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 59,
    r: 2.5,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 114.5,
    width: 115,
    height: 42,
    rx: 7.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.709 127.958L158.959 132.562L163.292 124.708",
    stroke: "black",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 138.5,
    width: 85,
    height: 8,
    rx: 4,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 124.5,
    width: 85,
    height: 8,
    rx: 4,
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 81.5,
    width: 115,
    height: 28,
    rx: 7.5,
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.709 94.958L158.959 99.5622L163.292 91.708",
    stroke: "black",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 91.5,
    width: 85,
    height: 8,
    rx: 4,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 43.5,
    r: 2,
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 20.5,
    r: 2,
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 163.5,
    r: 2,
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 157,
    r: 16,
    fill: "#65C466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.777 156.112L154.111 163.667L161.222 150.778",
    stroke: "white",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4286_47379",
    x1: 47.7504,
    y1: 35.3452,
    x2: 176.452,
    y2: 94.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6BAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB97E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneLogo);
export default __webpack_public_path__ + "static/media/done_logo.027a431ad5294f5e5e3383871064681c.svg";
export { ForwardRef as ReactComponent };